import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.15,
}));

const styles = makeStyles<Theme>((theme) => ({
  title: {
    lineHeight: "18px",
    margin: "16px 0px",
  },
  mb16: {
    marginBottom: "8px",
  },
  dateAtualField: {
    maxWidth: "20% !important",
    [theme.breakpoints.down("lg")]: {
      maxWidth: "20% !important",
    },
    [theme.breakpoints.down(1025)]: {
      maxWidth: "50% !important",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50% !important",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100% !important",
    },
  },
  emptyMessage: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#465869",
    margin: "4px 0px",
  },
}));

export default styles;
